/// Menu
import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { Link } from "react-router-dom";

/// Image
//import profile from "../../../images/profile/pic1.jpg";
//import plus from "../../../images/plus.png";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {}
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    //sidebar icon Heart blast
    var handleheartBlast = document.querySelector(".heart");
    function heartBlast() {
      return handleheartBlast.classList.toggle("heart-blast");
    }
    handleheartBlast.addEventListener("click", heartBlast);
  }, []);
  let scrollPosition = useScrollPosition();
  /// Path
  const path = window.location.pathname;
  return (
    <div
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="deznav-scroll">
        <MM className="metismenu" id="menu">
          <li
            className={`${
              path === "/" || path === "/dashboard" ? "mm-active" : ""
            }`}
          >
            <Link className="" to="/">
              <i className="fa fa-tv text-white"></i>
              <span className="nav-text">Dashboard</span>
            </Link>
          </li>
          <li className={`${path === "/Users" ? "mm-active" : ""}`}>
            <Link className="" to="/Users">
              <i className="fa fa-user text-white"></i>
              <span className="nav-text">Users</span>
            </Link>
          </li>
          <li className={`${path === "/recruiters" ? "mm-active" : ""}`}>
            <Link className="" to="/recruiters">
              <i className="fa fa-users text-white"></i>
              <span className="nav-text">Recruiters</span>
            </Link>
          </li>

          <li className={`${path === "/Jobs" ? "mm-active" : ""}`}>
            <Link className="" to="/Jobs">
              <i className="fa fa-briefcase text-white"></i>
              <span className="nav-text">Applied Jobs</span>
            </Link>
          </li>
          <li className={`${path === "/industry" ? "mm-active" : ""}`}>
            <Link className="" to="/industry">
              <i className="fa fa-building text-white"></i>
              <span className="nav-text">Industry</span>
            </Link>
          </li>
          <li className={`${path === "/agreeuser" ? "mm-active" : ""}`}>
            <Link className="" to="/agreeuser">
              <i className="fa fa-user text-white"></i>
              <span className="nav-text">Agreed User</span>
            </Link>
          </li>
          <li className={`${path === "/packages" ? "mm-active" : ""}`}>
            <Link className="" to="/packages">
              <i className="fa fa-dollar text-white"></i>
              <span className="nav-text">Packages</span>
            </Link>
          </li>
        </MM>
        <div className="copyright">
          <p>
            <strong>Job Link Zinad</strong> © 2021 All Rights Reserved
          </p>
          <p className="fs-12">
            Made with <span className="heart"></span> by HnHTechSolutions
          </p>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
